import { AuthService } from './../auth.service';
import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHandler } from '@angular/common/http';
import { Adal5HTTPService, Adal5Service } from 'adal-angular5';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-protected',
  templateUrl: './protected.component.html',
  styleUrls: ['./protected.component.scss']
})

export class ProtectedComponent implements OnInit {

  name: String = "";
  values: Array<any>;
  constructor(private _authService: AuthService, private adal5HttpService: Adal5HTTPService, private adal5Service: Adal5Service) { }

  ngOnInit() {
    this.name = this._authService.getName();
    this.getValues();
  }

  getValues() {

    //const headers = new Headers();
    //headers.append("Authorization", `Bearer: ${this._authService.getToken()}`);

    //const requestOptions = new RequestOptions();
    //requestOptions.headers = headers;

    //this.http.get('http://localhost:52653/api/hello', requestOptions).subscribe(data => {
    //  this.values = data.json();
    //});

    //const options = this.prepareOptions();
    //this.adal5HttpService.get('http://localhost:52653/api/hello', options).subscribe(data => {
    //  this.values = data;
    //});


  }

  private prepareOptions(): any {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${this.adal5Service.userInfo.token}`);
    return { headers };
  }

  public signout(): void {
    this._authService.signout();
  }
}



// WEBPACK FOOTER //
// ./src/app/protected/protected.component.ts